import { Routes } from '@angular/router';
import { HomeComponent } from "./components/home/home.component";
import { StoryboardGeneratorComponent } from "./components/storyboard-generator/storyboard-generator.component";
import { Storyboard3dComponent } from "./components/storyboard3d/storyboard3d.component";
import { VisualNarrativeMakerComponent } from "./components/visual-narrative-maker/visual-narrative-maker.component";
import { KeyVisualSplitterComponent } from "./components/key-visual-splitter/key-visual-splitter.component";
import { CustomModelGeneratorComponent } from "./components/custom-model-generator/custom-model-generator.component";
import { AdobeStatusComponent } from "./components/adobe-status/adobe-status.component";
import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";
import { testPageGuard } from "./guards/test-page.guard";

export const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'storyboard', component: StoryboardGeneratorComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'storyboard3d', component: Storyboard3dComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'visual-narrative-maker', component: VisualNarrativeMakerComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'key-visual-splitter', component: KeyVisualSplitterComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'custom-model-generator', component: CustomModelGeneratorComponent, canActivate: [autoLoginPartialRoutesGuard] },
    { path: 'adobe-status', component: AdobeStatusComponent, canActivate: [autoLoginPartialRoutesGuard, testPageGuard] },
    { path: '**', redirectTo: '' }
];
